/**
 * Video Configuration
 * Add your Instagram reel videos and example videos here
 *
 * For production: Use CDN URLs (Vercel Blob, Cloudinary, Railway, etc.)
 * For local development: Use /videos/ paths (files in public/videos/)
 *
 * Set VITE_VIDEO_CDN_URL in .env to use CDN for all videos.
 * Examples:
 *   Vercel Blob: https://xxxxx.public.blob.vercel-storage.com/videos
 *   Cloudinary:  https://res.cloudinary.com/your-cloud/video/upload
 */

// Vercel Blob – full URLs (no env, no fallback to /videos/)
export const REEL_VIDEOS = [
  {
    id: 'batting-highlights',
    title: 'Batting Highlights',
    description: 'Powerful shots, boundaries, sixes',
    videoUrl: 'https://8krgnqef6dpsxbbx.public.blob.vercel-storage.com/batting-reel.mp4',
    thumbnail: '/images/batting-thumbnail.jpg',
    type: 'video',
  },
  {
    id: 'bowling-magic',
    title: 'Bowling Magic',
    description: 'Yorkers, wickets, celebrations',
    videoUrl: 'https://8krgnqef6dpsxbbx.public.blob.vercel-storage.com/bowling-reel.mp4',
    thumbnail: '/images/bowling-thumbnail.jpg',
    type: 'video',
  },
  {
    id: 'fielding-excellence',
    title: 'Fielding Excellence',
    description: 'Catches, run-outs, saves',
    videoUrl: 'https://8krgnqef6dpsxbbx.public.blob.vercel-storage.com/bowling-reel.mp4',
    thumbnail: '/images/bowling-thumbnail.jpg',
    type: 'video',
  },
]

export const EXAMPLE_VIDEO = {
  youtubeId: '',
  videoUrl: 'https://8krgnqef6dpsxbbx.public.blob.vercel-storage.com/example-highlight.mp4',
  type: 'video',
  title: 'Example Highlight Video',
  description: 'This is how your match will look after professional editing',
}

// Instructions:
// 1. For CDN hosting (production):
//    - Upload videos to Cloudinary/Railway Object Storage/AWS S3
//    - Set VITE_VIDEO_CDN_URL in .env (e.g., https://res.cloudinary.com/your-cloud/video/upload)
//    - Or override videoUrl directly in each video object above
//
// 2. For local development:
//    - Place .mp4 files in public/videos/ folder
//    - Don't set VITE_VIDEO_CDN_URL (or leave empty)
//    - Videos will use /videos/ paths
//
// 3. For YouTube:
//    - Upload to YouTube and get video ID
//    - Use youtubeId instead of videoUrl
//    - Set type: 'youtube'
//
// 4. Video files are excluded from git (in .gitignore) due to size limits
